import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TCampaignStats } from "../types";

export const QUERY_KEY_CAMPAIGN_STATS = "admin-campaign-stats";

const getData = async (props: {
  token: string;
  id: string;
  from?: string;
  to?: string;
}): Promise<TCampaignStats> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/campaigns/${props.id}/stats`;
  const res = await axios.get<TCampaignStats>(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params: {
      ...(props.from ? { from: props.from } : {}),
      ...(props.to ? { to: props.to } : {}),
    },
  });
  return res.data;
};

export const useGetCampaignStats = (
  id?: string,
  from?: string,
  to?: string
) => {
  const { token } = useGetUserInfo();
  return useQuery(
    [QUERY_KEY_CAMPAIGN_STATS, id, from ?? "", to ?? ""],
    () => getData({ token, id: id!, from, to }),
    { enabled: !!id }
  );
};
